var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isEIAdmin)?_c('session-lookup',{attrs:{"expanded":_vm.expanded},on:{"showTable":function($event){return _vm.displayTable()},"toggleExpand":function($event){return _vm.toggleExpand()}}}):_vm._e(),(_vm.showTable)?_c('client-chart'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }